import { createBinderlessComponentImplementation } from '@a2ui/react/v0_9';
import { Catalog } from '@a2ui/web_core/v0_9';
import { z } from 'zod';

import { PhoneReportPreviewCard } from './PreviewCards';

import type { PhoneReportData } from '../types';

export const DEEP_SEARCH_CATALOG_ID = 'deepsearch-phone-report-v1';

const PhoneReportPreview = createBinderlessComponentImplementation(
  {
    name: 'PhoneReportPreview',
    schema: z.object({}).strict(),
  },
  ({ context }) => {
    const value = context.dataContext.dataModel.get('/') as
      | Record<string, unknown>
      | undefined;

    if (!value) {
      return null;
    }

    const data: PhoneReportData = {
      phoneNumber: String(value.phoneNumber ?? ''),
      fraudRisk: String(value.fraudRisk ?? ''),
      fraudSeverity: normalizeFraudSeverity(value.fraudSeverity),
      leakedNumber: stripPrefix(value.statusLeaked, 'Leaked Number: '),
      userActivity: stripPrefix(value.statusActivity, 'User Activity: '),
      dncStatus: String(value.statusDnc ?? 'Not on DNC List'),
      carrier: String(value.carrier ?? ''),
      prepaid: String(value.prepaid ?? ''),
      lineType: String(value.lineType ?? ''),
      validNumber: String(value.validNumber ?? ''),
      location: String(value.location ?? ''),
      zipCode: String(value.zipCode ?? ''),
      timeZone: String(value.timeZone ?? ''),
      ownersCount: normalizeOwnersCount(value.ownersCount),
      ownerName: String(value.ownerName ?? ''),
    };

    return <PhoneReportPreviewCard data={data} />;
  }
);

export const deepSearchCatalog = new Catalog(DEEP_SEARCH_CATALOG_ID, [
  PhoneReportPreview,
]);

const FRAUD_SEVERITIES = ['high', 'medium', 'low'] as const;

function normalizeFraudSeverity(raw: unknown): 'high' | 'medium' | 'low' {
  const s = String(raw ?? '').toLowerCase();
  return (FRAUD_SEVERITIES as readonly string[]).includes(s)
    ? (s as 'high' | 'medium' | 'low')
    : 'low';
}

function normalizeOwnersCount(raw: unknown): number {
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? Math.round(n) : 1;
}

function stripPrefix(raw: unknown, prefix: string): string {
  const s = String(raw ?? '');
  return s.startsWith(prefix) ? s.slice(prefix.length) : s;
}
